<template>
    <div class="panel panel-default">
        <div class="panel-heading">
            <h3>Пользователи</h3>
        </div>

        <panel-search @search="search" placeholder="Введите фио, телефон или почту для поиска"></panel-search>

        <table class="table table-striped">
            <thead>
            <tr>
                <th>ФИО</th>
                <th>Телефон</th>
                <th>E-mail</th>
                <th>Сегодня</th>
                <th>Неделя</th>
                <th>Месяц</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users">
                <td>
                    <a :href="`/users/${user.id}`">{{user.full_name}}</a>
                </td>
                <td>{{user.phone}}</td>
                <td>{{user.email}}</td>
                <td>{{user.count_user_inspection}}</td>
                <td>{{user.count_user_inspection_week}}</td>
                <td>{{user.count_user_inspection_month}}</td>
            </tr>
            </tbody>
        </table>

        <button class="load-more" v-if="next_page_url" @click="loadNextPage">Еще</button>
    </div>
</template>
<script>
    import axios from 'axios'
    import _ from 'lodash'

    export default {
        data() {
            return {
                q: '',
                loading_next_page: null,
                next_page_url: null,
            }
        },
        props: ['salon_id'],
        asyncComputed: {
            users() {
                return axios
                    .get('/api/users', {
                        params: {
                            q: this.q,
                            salon_id: this.salon_id,
                            null_salon_id: false,
                        }
                    })
                    .then(({data}) => {
                        this.next_page_url = data.next_page_url
                        return data.data
                    })
            },
        },
        methods: {
            search(q) {
                this.q = q
            },
            loadNextPage() {
                if (!this.loading_next_page) {
                    this.loading_next_page = axios
                        .get(this.next_page_url)
                        .then(({data}) => {
                            this.next_page_url = data.next_page_url
                            this.users = this.users.concat(data.data)
                        })
                        .finally(() => this.loading_next_page = null)
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// ShowSupervisor.vue?d6c0a5ca